export enum SaleStatus {
  Planned = 'PLANNED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}
